import { Model } from "../../model/model";

export interface CheckBoxItemModel {
    label: string;
    disabled?: boolean;
    checked?: boolean;
    object?: Model; 
}